export default __webpack_public_path__ + "static/media/donor_2.428d2740.jpg";